/**
 * @generated SignedSource<<0497a396c455bf4f6f5e0e3fb641ee94>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatabaseActionMenu_viewer$data = {
  readonly me: {
    readonly apps: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly organizationSlug: string | null | undefined;
      readonly slug: string;
    }>;
    readonly id: string;
    readonly organizations: ReadonlyArray<{
      readonly apps: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly slug: string;
      }>;
      readonly id: string;
      readonly name: string;
      readonly slug: string;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "DatabaseActionMenu_viewer";
};
export type DatabaseActionMenu_viewer$key = {
  readonly " $data"?: DatabaseActionMenu_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DatabaseActionMenu_viewer">;
};

import DatabaseActionMenuRefetchQuery_graphql from './DatabaseActionMenuRefetchQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": DatabaseActionMenuRefetchQuery_graphql
    }
  },
  "name": "DatabaseActionMenu_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "App",
          "kind": "LinkedField",
          "name": "apps",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "organizationSlug",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "organizations",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "App",
              "kind": "LinkedField",
              "name": "apps",
              "plural": true,
              "selections": [
                (v0/*:: as any*/),
                (v1/*:: as any*/),
                (v2/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "35e625608d74b9ff45e77c480badbc7a";

export default node;
